var s,
DeploymentMap = {

    // settings: {
    // },

    init: function() {
        //s = this.settings;
        this.loadMarkers();
    },

    loadMap: function(locations) {

        var bounds = new google.maps.LatLngBounds();
        var customZoom = $('#map-canvas').data('zoom');
        var customMobileZoom = $('#map-canvas').data('mobilezoom');
        var zoomLevel;
        if (Foundation.MediaQuery.current == 'small') {
            zoomLevel = 4;
        } else {
            zoomLevel = 3;
        }

    	var mapOptions = {
    		scrollwheel: false,
    		mapTypeControl: false,
    		//zoomControl: false,
    		// zoom: zoomLevel,
    		//center: rauschLatLng,
    		styles:[{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"off"},{"saturation":"0"},{"color":"#f3f3f3"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"saturation":"0"},{"color":"#f3f3f3"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"on"},{"color":"#f3f3f3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}]
    	};

    	var hfMap = new google.maps.Map(document.getElementById('map-canvas'),
    		mapOptions);
        //var markers = markers;

    	// var marker = new google.maps.Marker({
    	// 	position: rauschLatLng,
    	// 	map: hfMap,
    	// 	icon: 'themes/rauschcoleman/images/icon-map-marker.png'
    	// });

        // var markers = [
        //     ['Valley View Estates, Farmington', 36.009733,-94.278575],
        //     ['Summerlin, Bentonville', 36.321330,-94.249289]
        // ];

        //var markers = loadMarkers();
        //console.log(loadMarkers());

        locations.forEach(location => {
            var position = new google.maps.LatLng(location.Latitude, location.Longitude);
            bounds.extend(position);
            const svgMarker = {
              path: "M 0 0 m -15 0 a 15 15 0 1 0 30 0 a 15 15 0 1 0 -30 0",
              fillColor: "#3397DE",
              fillOpacity: 0.25,
              strokeColor: "#3397DE",
              strokePosition: "outside",
              strokeWeight: 10,
              strokeOpacity: .1,
              rotation: 0,
              scale: 1,
              // anchor: new google.maps.Point(0,0),
            };
            var marker = new google.maps.Marker({
                position: position,
                map: hfMap,
                title: location.Title,
                optimized:false,
                icon: svgMarker,
            });

            var infowindow = new google.maps.InfoWindow({maxWidth:450});

            // Allow each marker to have an info window
            google.maps.event.addListener(marker, 'click', (function(marker, location) {
                return function() {
                    markerTitle = '<h4 class="title">'+marker.title+'</h4>';
                    markerContent = markerTitle;
                    infowindow.setContent(markerContent);
                    infowindow.open(hfMap, this);
                    placeholderVal = "I\'m interested in more information about the "+marker.title+" community!";
                    $('#request-info-form_Comments').val(placeholderVal);
                    $('#request-info-form_SubDivisionID').val(marker.subID);

                    // $('.sub-panel').removeClass('active');
                    // $('#panel-'+markers[i][3]).addClass('active');
                //     infoWindow.setContent(infoWindowContent[i][0]);
                //     infoWindow.open(hfMap, marker);
                }
            })(marker, location));

            // Automatically center the map fitting all markers on the screen
            //console.log(bounds);
            hfMap.fitBounds(bounds);
        });
        var boundsListener = google.maps.event.addListener((hfMap), 'bounds_changed', function(event) {
            this.setZoom(zoomLevel);
            google.maps.event.removeListener(boundsListener);
        });

        if (Foundation.MediaQuery.current == 'small') {
            if (customMobileZoom > 0) {
                setTimeout(function(){
                    hfMap.setZoom(customMobileZoom);
                }, 900);
            }
        } else {
            if (customZoom > 0) {
                setTimeout(function(){
                    hfMap.setZoom(customZoom);
                }, 500);
            }
        }


    	// Reset center point on window resize (responsive)
    	// google.maps.event.addDomListener(window, "resize", function() {
    	//     var center = hfMap.getCenter();
    	//     google.maps.event.trigger(hfMap, "resize");
    	//     hfMap.setCenter(center);
    	// });

    	// google.maps.event.addListener(marker, 'click', function() {
    	// 	infowindow.open(hfMap,marker);
    	// });
    },

    loadMarkers: function() {

        var markers = $.getJSON('ajax/locations/', function(data){
            console.log('Map marker ready');
            DeploymentMap.loadMap(data);
        });

    }

};
